<template>
    <div>
        <div>
            <el-link :disabled="row.status !== 2" class="color-blue" @click="changeTask(row)">转任务</el-link>
            <el-link :disabled="row.status !== 2" class="color-blue" @click="changeTaskJb(row)">转交办</el-link>
        </div>

        <taskDia v-if="taskDiaShow" />
        <taskJbDia v-if="taskJbDiaShow" />
    </div>
</template>

<script>
import taskDia from './components/taskDia'
import taskJbDia from './components/taskJbDia'
export default {
    components: {
        taskDia,
        taskJbDia
    },
    props: {
        column: { type: Object, default: null },
        row: { type: Object, default: null },
        index: { type: Number, default: null }
    },
    data() {
        return {
            taskDiaShow: false,
            taskJbDiaShow: false
        }
    },
    methods: {
        changeTask(row) {
            if (row.passenger && row.passenger.hyapYtInfos && row.passenger.hyapYtInfos.length > 0) {
                this.taskDiaShow = true
                this.$nextTick(() => {
                    this.$bus.emit('taskDiaShow', row.passenger.hyapYtInfos)
                })
            }
        },
        changeTaskJb(row) {
            if (row.passenger && row.passenger.hyapYtInfos && row.passenger.hyapYtInfos.length > 0) {
                this.taskJbDiaShow = true
                this.$nextTick(() => {
                    this.$bus.emit('taskJbDiaShow', row.passenger.hyapYtInfos)
                })
            }
        }
    }
}
</script>

<style scoped lang="scss"></style>
